import React, { useCallback, useEffect, useRef, useState } from 'react'

import { Button, Grid, Input, Line, SelectForm } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import useLoading from 'hooks/useLoading'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { ProfileUserServices } from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'
import { PerfilUsuario, UsuarioFornecedor } from 'utils/types'

import { NovoUsuarioForm } from '../ModalNewUser/ModalNewUser'
import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalEditUser.styles'

interface IModalEditUser {
  isAdmin?: boolean
  showModal: boolean
  toggleModal: () => void
  onSubmit: any
  userData: UsuarioFornecedor
}
const ModalEditUser: React.FC<IModalEditUser> = ({
  isAdmin,
  onSubmit,
  showModal,
  toggleModal,
  userData
}) => {
  const [listProfiles, setListProfiles] = useState<
    PerfilUsuario[] | undefined
  >()
  const { setLoading, setMsgErro } = useLoading()
  const { reset, watch, control, handleSubmit, formState } =
    useForm<NovoUsuarioForm>()

  const cpfPass = watch('cdDocto')

  const getProfiles = useCallback(async () => {
    setLoading('loading')
    try {
      const response = await ProfileUserServices().getSuppliers()
      setListProfiles(response.data)
      setLoading('idle')
    } catch (error) {
      setLoading('error')
      setMsgErro(error.toString())
    }
  }, [])
  useEffect(() => {
    getProfiles()
  }, [])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={showModal}
      width="md"
      onClose={() => {
        toggleModal()
        reset()
      }}
    >
      <Line />
      <FormDialog
        onSubmit={handleSubmit((data) => {
          onSubmit(data)
          reset()
          toggleModal()
        })}
      >
        <DialogTitleStyled>Editar Usuário</DialogTitleStyled>
        <DialogContentStyled>
          <Grid
            gridCols="2fr 1fr"
            gridGap="1rem"
            margin={`${SPACING.spacing10} 0 ${SPACING.spacing20} 0`}
          >
            <Input
              label="Colaborador"
              formValue="nmUsuario"
              control={control}
              errors={formState.errors}
              defaultValue={userData?.usuario?.nmUsuario}
              disabled
            />
            <Input
              label="CPF/Passaporte"
              mask={
                isNaN(parseInt(cpfPass)) ? ['NN##########'] : ['###.###.###-##']
              }
              formValue="cdDocto"
              control={control}
              errors={formState.errors}
              defaultValue={userData?.usuario?.cdDocto}
              disabled
            />
          </Grid>
          <Grid gridCols="2.2fr 1fr 1.8fr" gridGap="1rem" margin="1rem 0 0 0">
            <Input
              defaultValue={userData?.usuario?.txEmail}
              label="E-mail"
              formValue="txEmail"
              control={control}
              errors={formState.errors}
              disabled
            />
            <Input
              defaultValue={userData?.usuario?.nuContato}
              label="Contato"
              formValue="nuContato"
              mask={['(##) ####-####', '(##) #####-####']}
              control={control}
              errors={formState.errors}
              disabled
            />
            <SelectForm
              defaultValue={userData?.usuario?.perfilUsuarioId}
              control={control}
              formValue="perfilUsuarioId"
              disabled={!isAdmin}
              errors={formState.errors}
              required
              listOptions={listProfiles}
              label="Perfil"
              valueMenu="idPerfilUsuario"
              labelMenu="txDenominacao"
            />
          </Grid>
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            backgroundColor={COLORS.white}
            textColor={COLORS.black}
            marginRight={SPACING.spacing20}
            borderColor={COLORS.black}
            onClick={() => {
              toggleModal()
              reset()
              resetModalState(draggableReference)
            }}
          />
          <Button disabled={!isAdmin} text="Salvar" type="submit" />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalEditUser
